import "./style.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import PopupAHSF from "../../../../Components/PopupAHSF";
import TableAHSF from "../../../../Components/TableAHSF";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
const TransferBetweenResidentsTable = (props) => {
    const arrayDataCheckBoks = useSelector(
      (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["SubtasksList"]
    );

  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "researcherName",
      ShowStatus: true,
      NmaeColumn: "اسم المتقدم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "researcherName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "foundationName",
      ShowStatus: true,
      NmaeColumn: "اسم المؤسسة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "foundationName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "researchProjectTitleInArabic",
      ShowStatus: true,
      NmaeColumn: "اسم المشروع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "researchProjectTitleInArabic",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
      console.log(arrayDataCheckBoks, "ssssssdwdwdddd");

  const RequestsManagerBtns = [];

  const RequestsManagerColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";

  useEffect(() => {
    dispatch(setRefreshTable());
  }, [
    props.DropDownFrom,
    props.fields,
    //  props.roundActive
  ]);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"taskId"}
        valueButtonAction={"taskId"}
        URL={`api/SubTasks/GetAllSubTasksByEvaluetorAssigninng`}
        UrlBody={{
          // roundYearId: props.roundActive,
          userGuid: props.DropDownFrom,
          fieldId: props.fields,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"subTaskId"}
        dataRedux={arrayDataCheckBoks}
        uniqeKeyNameRedux={"SubtasksList"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={true}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};
export default TransferBetweenResidentsTable;
